import { useState, useEffect } from "react";
import { obtenerListaTipoChecklist } from "../api/tipo-checklist";
import { useTranslation } from "react-i18next";
// import { obtenerListaArea } from "../api/area";
// import { obtenerListaCiudad } from "../api/ciudad";
// import { obtenerListaMarcaVehiculo } from "../api/marca-vehiculo";
// import { obtenerListaTipoCombustible } from "../api/tipo-combustible";
import Select from "react-select";
import { ESTILO_BOTON_MODAL_ACEPTAR, ESTILO_BOTON_MODAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../utils/const/estilos-const";
// import { obtenerListaTipoCarroceria } from "../api/tipo-carroceria";
// import { obtenerListaTipoVehiculo } from "../api/tipo-vehiculo";

export default function ModalCrearChecklist({ isOpen, onCancel, onConfirm, elemento, handleInputChange }) {
    const { t } = useTranslation();

    const [listaTipoChecklist, setListaTipoChecklist] = useState([]);
    const [tipoChecklistSelected, setTipoChecklistSelected] = useState(null);

    useEffect(() => {
        iniciar();
    }, []);

    useEffect(() => {
        if (isOpen) {
            setTipoChecklistSelected(null);
        }
    }, [isOpen]);

    const iniciar = async () => {
        try {
            // console.log('iniciar');
            const listaTC = await obtenerListaTipoChecklist(true);
            setListaTipoChecklist(listaTC);

        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        }
    }

    const onPressCancelar = () => {
        setTipoChecklistSelected(null);
        onCancel();
    }

    const onPressCrear = () => {
        onConfirm(tipoChecklistSelected);
    }

    return (
        <>
            {isOpen && (
                <div className="fixed z-50 top-0 left-0 right-0 bottom-0 flex items-center justify-center">
                    <div className="fixed inset-0 bg-gray-500 opacity-75"></div>
                    <div className="bg-white w-11/12 md:max-w-5xl mx-auto rounded shadow-lg z-50 overflow-y-auto flex flex-col">
                        <div className="pt-4 text-left px-6">
                            <h2 className="text-lg font-bold mb-4">{t('titulo_crear_nuevo_checklist')}</h2>
                        </div>
                        <div className="text-left px-6">
                            <div className="grid grid-cols-4 gap-4 mb-4">
                                <div className="col-span-2">
                                    <div className="flex items-center">
                                        <span className="text-red-500 font-bold">*</span>
                                        <label className="font-bold ml-1">{t('label_nombre_checklist')}</label>
                                    </div>
                                    <input
                                        id="nombre"
                                        name="nombre"
                                        type="text"
                                        value={elemento.nombre}
                                        onChange={handleInputChange}
                                        className={ESTILO_INPUT_GENERICO}
                                        required
                                        maxLength={255}
                                    />
                                </div>
                            </div>
                            <hr />
                            <div className="grid grid-cols-4 gap-4 mb-4">
                                <div className="col-span-1">
                                    <label className="font-bold">{t('label_tipo_checklist')}</label>
                                    <Select
                                        options={listaTipoChecklist}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={tipoChecklistSelected}
                                        onChange={(e) => {
                                            setTipoChecklistSelected(e);
                                        }}
                                        placeholder={t('label_tipo_checklist')}
                                    />
                                </div>
                            </div>
                            <hr />
                            <hr />
                            <div className="grid grid-cols-4 gap-4 mb-4">
                                <div className="col-span-2">
                                    <label className="font-bold">{t('label_nota')}</label>
                                    <textarea
                                        id="nota"
                                        name="nota"
                                        type="text"
                                        value={elemento.nota}
                                        onChange={handleInputChange}
                                        className={ESTILO_INPUT_GENERICO}
                                        required
                                        maxLength={2047}
                                    />
                                </div>
                            </div>
                        </div>
                        <br />
                        <hr />
                        <div className="py-4 text-left px-6">
                            <div className="flex justify-end">
                                <button
                                    className={ESTILO_BOTON_MODAL_CANCELAR}
                                    onClick={onPressCancelar}
                                >
                                    {t('btn_cancelar')}
                                </button>
                                <button
                                    className={ESTILO_BOTON_MODAL_ACEPTAR}
                                    onClick={onPressCrear}
                                >
                                    {t('btn_crear')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

// export default ModalCrearChecklist;